import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b45817c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "widget-content"
}
const _hoisted_2 = { class: "widget-headline" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "widget-text" }, "Low Rated HoC", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hoc-combined-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hoc-icon rating12" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hoc-icon rating-empty" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hoc-icon rating0" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hoc-icon rating34" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "widget",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoHocRatings && _ctx.gotoHocRatings(...args)))
  }, [
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.state === 'loading')
          ? (_openBlock(), _createBlock(_component_ion_spinner, {
              key: 0,
              name: "crescent"
            }))
          : (_ctx.state === 'loaded')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.value), 1),
                _hoisted_3,
                _hoisted_4
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}